export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6284.b285b388.jpg";